import {HttpClient, HttpHandler, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { env } from 'process';
import {Observable} from 'rxjs';
import { ApplicationPaymentPageFormData } from 'src/app/interfaces/paymentPage/application-payment-page-form-data';
import { environment } from 'src/environments/environment';

@Injectable()

export class PaymentPageApi extends HttpClient {
    private baseUrl = environment.production ? "/channel-virtual/api/v1/application-payment-page" : environment.baseUrl+"/application-payment-page";
    private loginUrl = environment.production ? '/channel-virtual' + '/login' : environment.baseUrlLogin + '/login';

    public constructor(handler: HttpHandler) {
      super(handler);
    }

    public getApplicationPaymentPageData(token:string): Observable<any> {
      let url = this.baseUrl+'/?paymentPageUid='+token;
      const options=new HttpHeaders();
      const authToken = sessionStorage.getItem('authToken');
      options.set('Authorization', `Bearer ${authToken}`);
      return super.get(url,{
        headers:options
      });
    }

    public getJWToken(payload:ApplicationPaymentPageFormData,token:string):Observable<any>{
      let url = this.baseUrl+'/tokenise?paymentPageUid='+token;
      const options=new HttpHeaders();
      const authToken = sessionStorage.getItem('authToken');
      options.set('Authorization', `Bearer ${authToken}`);
      return super.post(url,payload);
    }

    public getMerchantInformation(token:string):Observable<any>{
      let url = this.baseUrl+'/merchant?paymentPageUid='+token;
      const options=new HttpHeaders();
      const authToken = sessionStorage.getItem('authToken');
      options.set('Authorization', `Bearer ${authToken}`);
      return super.get(url,{
        headers:options
      });
    }

    public getMerchantConfig(merchantUid:string, applicationUid:string):Observable<any>{
      let url = `${this.baseUrl}/merchant-config?merchantUid=${merchantUid}&applicationUid=${applicationUid}`;
      const options=new HttpHeaders();
      const authToken = sessionStorage.getItem('authToken');
      options.set('Authorization', `Bearer ${authToken}`);
      return super.get(url,{
        headers:options
      });
    }

    public login():Observable<any>{
      return super.get(this.loginUrl);
    }
}
